import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { DataSourceResponse, MedRecord } from '../../models';
import { HttpParamsEncoder } from '../../tools';


@Injectable({ providedIn: 'root' })
export class MedRecordService extends ApiService {
    endPoint = '/api/medrecords';
    create(model: MedRecord) {
        return this.http.post(`${this.clinicsBaseURL}${this.endPoint}`, model);
    }
    update(id: string, model: MedRecord) {
        return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}`, model);
    }
    getById(id: string) {
        return this.http.get<MedRecord>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
    }
    getByRegisterPatientId(id: string) {
        return this.http.get<MedRecord>(`${this.clinicsBaseURL}${this.endPoint}/by-register-patient/${id}`);
    }
    getByCaseHistoryNarrowId(id: string) {
        return this.http.get<MedRecord>(`${this.clinicsBaseURL}${this.endPoint}/by-case-history-narrow/${id}`);
    }
    sign(id: string) {
        return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/Sign/${id}`, {});
    }
    signWithESI(id: string, esiInfo: any) {
        return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/Sign/${id}`, esiInfo);
    }
    updatePdf(id: string) {
        return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/updatePdf/${id}`, {});
    }
    asPdf(id: string) {
        return this.http.get(`${this.clinicsBaseURL}${this.endPoint}/${id}/aspdf`, { responseType: 'blob' as 'json' });
    }
    getList(queryParams: any): Observable<DataSourceResponse<MedRecord>> {
        const params = new HttpParamsEncoder().encode(queryParams);
        return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
    }

}
